import React from "react";
import { Link } from "react-router-dom";
import { PlanItem } from "../../../models/user";

const Save40: React.FC = () => {
  const plans_data: PlanItem[] = JSON.parse(
    localStorage.getItem("plans_data") || "{}",
  );
  const monthly_plan = plans_data.find((plan) => plan.id === "1");
  return (
    <div className="section section_07" id="section_07">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col_right bg-white py-2">
            <PriceGrid />
          </div>
          <div className="col-lg-5 col-lg-offset-1">
            <h2 className="text-left mb-0 mt-md-4">Have extra funds?</h2>
            <p className="mt-0">
              {" "}
              Buy multiple years now, so you don't have to worry about budgeting
              for next year!
            </p>
            <p>
              You get complete access to all of the short stories and novels for{" "}
              {monthly_plan?.students} students.
            </p>
            <p>
              We also have monthly subscriptions for $
              {monthly_plan?.price_amount} per month, which won't auto-renew.
            </p>
            <Link to="/signup" className="btn btn-warning mt-5 ">
              {" "}
              Start Your Free Trial
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

const plans = [
  {
    label: "1-Year Subscription",
    sku: "1B7050SUB1Y",
    price: "$149",
    popular: false,
  },
  {
    label: "3-Year Subscription",
    sku: "1B7050SUB3Y",
    price: "$447",
    popular: true,
  },
  {
    label: "5-Year Subscription",
    sku: "1B7050SUB5Y",
    price: "$745",
    popular: false,
  },
];

const PriceGrid: React.FC = () => (
  <table className="pricing-table">
    <thead>
      <tr>
        <th className="pricing-table__header-empty" scope="col" />
        <th className="pricing-table__header-label" scope="col">
          YOUR PRICE
          <br />
          TODAY!
        </th>
      </tr>
    </thead>
    <tbody>
      {plans.map((plan) => (
        <tr
          key={plan.sku}
          className={plan.popular ? "pricing-table__row--popular" : ""}
        >
          <th className="pricing-table__info" scope="row">
            <span className="pricing-table__name">{plan.label}</span>
            <span className="pricing-table__sku">{plan.sku}</span>
            {plan.popular && (
              <div className="pricing-table__badge">
                <span>MOST POPULAR</span>
              </div>
            )}
          </th>
          <td className="pricing-table__price">{plan.price}</td>
        </tr>
      ))}
    </tbody>
  </table>
);
export default Save40;
